module.exports = __webpack_public_path__ + "img/ai-back.39480268.svg";